import DemoPage from "./DemoPage"

export default DemoPage
